import { RouteMessages } from "api/routes/models";
import { Label } from "components/utils";
import { dateFns } from "utilities";
import styles from "./ConversationModal.module.css";

export const ConfirmedBy = ({ order }: { order: RouteMessages["orders"][number] }) => {
  if (order.deliveryDateConfirmedBy) {
    return (
      <div>
        <div className="d-flex align-items-center mb-1">
          <Label color="primary" className="mr-2">
            Milo
          </Label>
          <div className={styles.date}>
            {order.deliveryDateConfirmation &&
              dateFns.format(new Date(order.deliveryDateConfirmation), "dd.MM.yyyy HH:mm")}
          </div>
        </div>
        <div className={styles.name}>
          {order.deliveryDateConfirmedBy.firstName} {order.deliveryDateConfirmedBy.lastName}
        </div>
      </div>
    );
  }

  return (
    <div>
      <div className="d-flex align-items-center">
        <Label color="blue" className="mr-2">
          Klient
        </Label>
        <div className={styles.date}>
          {order.deliveryDateConfirmation &&
            dateFns.format(new Date(order.deliveryDateConfirmation), "dd.MM.yyyy HH:mm")}
        </div>
      </div>
    </div>
  );
};
